import { render, staticRenderFns } from "./FormCotizacionComponent.vue?vue&type=template&id=c1572140"
import script from "./FormCotizacionComponent.vue?vue&type=script&lang=js"
export * from "./FormCotizacionComponent.vue?vue&type=script&lang=js"
import style0 from "./FormCotizacionComponent.vue?vue&type=style&index=0&id=c1572140&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports